<script>
  import {SCORES}             from '../../../../constants/scores';
  import {scoresStore}        from '../../../../stores/filters/scores-store';
  import AllScoresFilterScore from './all-scores-filter-score/all-scores-filter-score.svelte';

  const scores = SCORES.filter((n) => n <= 3.5);

  const onClearAll = (_event) => {
    scoresStore.reset();
  };
</script>

<style>
  button {
    margin-left: 10px;
  }
</style>

<template lang="pug" src="./all-scores-filter.pug"></template>
